module.exports = __webpack_public_path__ + "img/217.1b92f1a8.png";